import React from "react";
import {Col} from "antd";
import {
    CompanyFilter,
    SubCompanyFilter,
    SearchText,
    CourierFilter,
    DateRangeFilter
} from "../../../_defaultComponents/FilterComponents";

export const BackofficeFailedPaymentsFilters = ({filters, setFilters}) => {
    return (
        <React.Fragment>
            <Col xs={24} sm={12} md={6} lg={6} xl={6}>
                <SearchText
                    value={filters.transactionId}
                    onChange={value => setFilters({...filters, transactionId: value})}
                    label="Ödeme Id"
                    showLabel={true}
                />
            </Col>

            <Col xs={24} sm={12} md={6} lg={6} xl={6}>
                <SearchText
                    value={filters.vigoOrderNumber}
                    onChange={value =>
                        setFilters({...filters, vigoOrderNumber: value.toUpperCase()})
                    }
                    label="Sipariş No"
                    showLabel={true}
                />
            </Col>

            <Col xs={24} sm={12} md={6} lg={6} xl={6}>
                <SearchText
                    value={filters.referenceCode}
                    onChange={value => setFilters({...filters, referenceCode: value.toUpperCase()})}
                    label="Referans Fatura No"
                    showLabel={true}
                />
            </Col>
            <Col xs={24} sm={12} md={6} lg={6} xl={6}>
                <SearchText
                    value={filters.invoiceDocumentId}
                    onChange={value =>
                        setFilters({...filters, invoiceDocumentId: value.toUpperCase()})
                    }
                    label="E-Fatura No"
                    showLabel={true}
                />
            </Col>
            <Col xs={24} sm={12} md={6} lg={6} xl={6}>
                <DateRangeFilter
                    value={[filters.startDate, filters.endDate]}
                    onChange={value =>
                        setFilters({...filters, startDate: value?.[0], endDate: value?.[1]})
                    }
                    label="İşlem Tarihi"
                    showLabel={true}
                />
            </Col>
            <Col xs={24} sm={12} md={6} lg={6} xl={6}>
                <DateRangeFilter
                    value={[filters.reconciliationStartDate, filters.reconciliationEndDate]}
                    onChange={value =>
                        setFilters({
                            ...filters,
                            reconciliationStartDate: value?.[0],
                            reconciliationEndDate: value?.[1]
                        })
                    }
                    label="Mutabakat Tarihi"
                    showLabel={true}
                />
            </Col>
            <Col xs={24} sm={12} md={6} lg={6} xl={6}>
                <DateRangeFilter
                    value={[filters.invoiceStartDate, filters.invoiceEndDate]}
                    onChange={value =>
                        setFilters({
                            ...filters,
                            invoiceStartDate: value?.[0],
                            invoiceEndDate: value?.[1]
                        })
                    }
                    label="E-Fatura Tarihi"
                    showLabel={true}
                />
            </Col>
            <Col xs={24} sm={12} md={6} lg={6} xl={6}>
                <DateRangeFilter
                    value={[filters.refundStartDate, filters.refundEndDate]}
                    onChange={value =>
                        setFilters({
                            ...filters,
                            refundStartDate: value?.[0],
                            refundEndDate: value?.[1]
                        })
                    }
                    label="Geri Ödeme Tarihi"
                    showLabel={true}
                />
            </Col>
        </React.Fragment>
    );
};
